import { render, staticRenderFns } from "./stop-subscriptions.vue?vue&type=template&id=704bf486&functional=true&"
import script from "./stop-subscriptions.vue?vue&type=script&lang=js&"
export * from "./stop-subscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports